<template>
  <div class="button-pair">
    <TextButton label="홈으로 이동" @click="$emit('home-click')" />
    <span class="button-pair__divider"></span>
    <TextButton label="로그아웃" @click="$emit('logout-click')" />
  </div>
</template>

<script>
import TextButton from '@/components/new/atoms/TextButton.vue'

export default {
  name: 'ButtonPair',
  components: {
    TextButton,
  },
}
</script>

<style scoped>
.button-pair {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 16px 0;
}

.button-pair__divider {
  width: 1px;
  height: 8px;
  border-radius: 100px;
  opacity: 0.5;
  background: #6B7684;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/ButtonPair.vue